import React from "react";
import { Card, Row, Col, Button } from "antd";
import { RiArrowGoBackFill } from "react-icons/ri";
import { UserEmailUpdateForm } from "@components";

const UserEmailUpdate = ({ history }) => {
  return (
    <>
      <Card style={{ borderRadius: "0", height: "100vh", overflowY: "auto" }}>
        <Row>
          <Col span={24}>
            <Row align="middle">
              <Col>
                <Button
                  type="link"
                  icon={<RiArrowGoBackFill style={{ fontSize: "2em" }} />}
                  onClick={() => history.push("/super-admin/email/users")}
                  style={{
                    marginRight: "16px",
                    padding: 0,
                    height: "auto",
                    display: "flex",
                    alignItems: "center",
                  }}
                />
              </Col>
              <Col>
                <h3
                  className="hp-mb-16"
                  style={{
                    fontSize: "1.75em",
                    margin: 0,
                  }}
                >
                  Update Email User
                </h3>
              </Col>
            </Row>
            {/* Space */}
            <Row style={{ marginTop: "1em" }} />
            {/* User Email Update Form */}
            <UserEmailUpdateForm />
          </Col>
        </Row>
      </Card>
    </>
  );
};

export default UserEmailUpdate;
